<template>
  <div class="table">
    <el-table
      v-if="data.length"
      :data="data"
      style="width: 100%"
      :header-cell-style="{ textAlign: 'center' }"
      :cell-style="{ textAlign: 'center' }"
      stripe
      height="100%"
    >
      <el-table-column type="index" label="序号" min-width="12%" />
      <el-table-column prop="word" label="关键词" min-width="50%" />
      <!-- <el-table-column prop="suggest" label="推荐理由" min-width="25%" /> -->
      <el-table-column prop="amount" label="月搜索（次）" min-width="25%" />
      <el-table-column label="竞争程度" min-width="13%">
        <template #default="{ row }">
          <div class="competition_level">
            <div
              class="item"
              v-for="(_item, index) in 5"
              :key="index"
              :class="{ active: row.competition_level > index }"
            ></div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <img class="empty" v-else src="@/assets/img/empty.png" />
  </div>
</template>

<script setup>
import { toRefs } from 'vue'

const props = defineProps({
  data: { type: Array, default: () => [] },
})
const { data } = toRefs(props)
</script>

<style scoped lang="scss">
.empty {
  max-width: 80%;
  margin: 0 auto;
  display: block;
}
.table {
  width: 100%;
  padding: 30px 0;
  flex: auto;
  overflow: hidden;
  .competition_level {
    display: flex;
    justify-content: center;
    .item {
      width: 6px;
      height: 6px;
      background-color: #d8d8d8;
      margin-right: 3px;
      &.active {
        background-color: #51ffe9;
      }
    }
  }
}
</style>
